import { createApp } from 'vue'
import App from '@/components/app/App.vue'
import { loadTranslations } from '@/js/global/vue-i18n'

const app = createApp(App)

loadTranslations(app).then(() => {
    app.mount("#app-vue")
})